var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",style:({ color: _vm.titleColor })},[_c('div',{staticClass:"jiantou",on:{"click":_vm.goBack}},[_c('img',{staticClass:"back_bg",attrs:{"src":_vm.backUrl,"alt":""}})]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }